import { Injectable } from '@angular/core';
import { MainService } from './main.service';

@Injectable({
  providedIn: 'root'
})

export class RellenoService {

    constructor(
        private main: MainService
    ) { }

    getLineasEstacionesData(id_camp: number){
      return this.main.getRequest(`/relleno/get_lineas_estaciones/${id_camp}`);
    }
    saveRelleno(data: any){
      return this.main.postRequest(data,"/relleno/save_relleno");
    }
    saveMovInv(data: any){
      return this.main.postRequest(data,"/relleno/save_mov_inv");
    }
    getRellenoHistorial(id_camp: number){
      return this.main.getRequest(`/relleno/get_relleno_historial/${id_camp}`);
    }

  
}